
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#8F7A61","viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 28.18c-.13 0-.26-.03-.38-.08L1.08 14.98c-.36-.15-.59-.5-.59-.89s.23-.74.59-.89L31.62.08a.94.94 0 01.77 0L62.92 13.2c.36.15.59.5.59.89s-.23.74-.59.89L32.38 28.11c-.12.05-.25.07-.38.07zM3.92 14.09L32 26.16l28.08-12.07L32 2.03z"}}),_c('path',{attrs:{"d":"M32 64c-.13 0-.26-.03-.38-.08L1.08 50.8a.96.96 0 01-.59-.89V14.09c0-.54.43-.97.97-.97s.97.43.97.97v35.18L32 61.97l29.57-12.71V14.09c0-.54.43-.97.97-.97s.97.43.97.97v35.82c0 .39-.23.74-.59.89L32.38 63.92c-.12.05-.25.08-.38.08z"}}),_c('path',{attrs:{"d":"M16.01 51.07c-.13 0-.26-.03-.38-.08L5.56 46.66c-.49-.21-.72-.78-.51-1.27s.78-.72 1.27-.51l10.06 4.33c.49.21.72.78.51 1.27a.94.94 0 01-.88.59zM12.98 44.94c-.13 0-.26-.03-.38-.08l-7.04-3.03c-.49-.21-.72-.78-.51-1.27s.78-.72 1.27-.51l7.03 3.03c.49.21.72.78.51 1.27-.14.37-.5.59-.88.59zM19.29 29.98c-.25 0-.49-.09-.68-.27-1.19-1.16-2.04-1.7-3.63-1.64-1.07.04-1.8-.66-2.26-1.13-.5-.5-.52-.49-.72-.39a.968.968 0 01-1.41-.87v-7.26c0-.39.23-.74.59-.89L41.71 4.42c.49-.21 1.06.02 1.27.51s-.02 1.06-.51 1.27L12.53 19.07v5.51c.72.14 1.23.65 1.57.99.39.39.62.57.82.56 1.4-.05 2.46.26 3.41.85v-5.23c0-.39.23-.74.59-.89L49.45 7.74c.49-.21 1.06.02 1.27.51s-.02 1.06-.51 1.27L20.26 22.39v6.62c0 .39-.23.74-.59.89-.12.06-.25.08-.38.08zM32 64c-.54 0-.97-.43-.97-.97V27.22c0-.54.43-.97.97-.97s.97.43.97.97v35.82c0 .53-.43.96-.97.96z"}})])
          )
        }
      }
    